import {Component, Input} from '@angular/core';
import {FamilyMemberResponse, MembershipResponse, UserResponse} from '../../../../@shared/models/response.module';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddMembership} from './components/add-membership/add-membership';
import {PurchaseMembership} from './components/purchase-membership/purchase-membership';
import {AQH_FAM_0, AQH_MEM_0, AQH_MEM_3} from '../../../../@shared/models/input.module';
import {MembershipService} from '../../../../@shared/services/membership-service';
import {formatTimeYMD} from '../../../../@core/utils/utils.service';
import {FamilyService} from '../../../../@shared/services/family-service';

@Component({
  selector: 'app-user-profile-membership',
  standalone: false,
  templateUrl: './user-profile-membership.html',
  styleUrl: './user-profile-membership.css'
})
export class UserProfileMembership {
  @Input() user: UserResponse
  memberShips: MembershipResponse[]

  constructor(private modal: NgbModal,
              private membershipService: MembershipService,
              private familyService: FamilyService) {
  }

  ngOnInit() {
    this.getUserMembership()
  }

  openMembershipModal(familyId: number) {
    let modalRef = this.modal.open(AddMembership, {size: 'lg', centered: true});
    modalRef.componentInstance.familyId = familyId
    modalRef.result.then((result) => {
      if (result) {
        this.getUserMembership()
      }
    })
  }

  getUserMembership() {
    let params: AQH_MEM_0 = {}

    this.membershipService.getUserMembership(params).subscribe((res) => {
      console.log("response membership: ", res);
      if (res) {
        console.log('User Membership: ', res);
        this.memberShips = res
      }
      else {
        alert("User Does not exist or is already a member of the family.")
      }
    })
  }

  removeMemberFromFamily(membership: MembershipResponse, member: FamilyMemberResponse) {
    let payload: AQH_FAM_0 = {
      family_id: membership.family?.family_id!,
      user_id: member.user.user_id
    }
    this.familyService.removeFamilyMember(payload).subscribe((res) => {
      this.getUserMembership()
    })
  }

  openPurchaseMembershipModal() {
    let modalRef = this.modal.open(PurchaseMembership, {size: 'lg', centered: true});
    modalRef.result.then((result) => {
      if (result) {
        this.getUserMembership()
      }
    }).catch(() => {});
  }

  cancelMembership(membership: MembershipResponse) {
    if (!confirm('Are you sure you want to cancel this membership?')) {
      return;
    }

    const payload: AQH_MEM_3 = {
      membership_id: membership.membership_id
    };

    this.membershipService.cancelMembership(payload).subscribe({
      next: () => {
        this.getUserMembership();
      }
    });
  }

  protected readonly formatTimeYMD = formatTimeYMD;
}
